import BouncySumsTableGrid from '@/features/bouncySums/components/BouncySumsTableGrid';
import Button from '@/shared/components/button/Button';

import '@/features/bouncySums/styles/bouncy-sums-start-screen.scss';

import type { BouncySumsLabels } from '@/features/bouncySums/types';

type BouncySumsStartScreenProps = {
	availableTables: number[];
	isLoadingQuestions: boolean;
	labels: BouncySumsLabels;
	selectedTables: number[];
	onStartGame: (event?: { currentTarget?: EventTarget | null }) => void;
	onTableToggle: (table: number) => void;
};

const BouncySumsStartScreen = ({
	availableTables,
	isLoadingQuestions,
	labels,
	onStartGame,
	onTableToggle,
	selectedTables,
}: BouncySumsStartScreenProps) => {
	return (
		<div className="bouncy-sums-start-screen">
			<div className="bouncy-sums-start-screen__content">
				<h1 className="bouncy-sums-start-screen__title">{labels.startTitle}</h1>
				<BouncySumsTableGrid
					availableTables={availableTables}
					selectedTables={selectedTables}
					onTableToggle={onTableToggle}
				/>
				<div className="bouncy-sums-start-screen__play-action">
					<Button
						btnType="button"
						type="primary"
						color="yellow"
						iconName="icon-play"
						title={selectedTables.length ? labels.playSelection : labels.playAll}
						loading={isLoadingQuestions}
						onClick={onStartGame}
						tabIndex={0}
						testId="bouncy-sums-play"
						className="bouncy-sums-start-screen__play-button"
					/>
				</div>
				<div className="bouncy-sums-start-screen__tip">
					<span>{labels.tip}</span>
					<span className="icon icon-volume-on" aria-hidden="true" />
				</div>
			</div>
		</div>
	);
};

export default BouncySumsStartScreen;
